export var TipoImovelEnum;
(function (TipoImovelEnum) {
    TipoImovelEnum["URBANO"] = "URBANO";
    TipoImovelEnum["RURAL"] = "RURAL";
})(TipoImovelEnum || (TipoImovelEnum = {}));
(function (TipoImovelEnum) {
    var mapDescricao = new Map([
        [TipoImovelEnum.RURAL, 'Imóvel Rural'],
        [TipoImovelEnum.URBANO, 'Imóvel Urbano'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoImovelEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoImovelEnum.getOptions = getOptions;
})(TipoImovelEnum || (TipoImovelEnum = {}));
